// 097 -- Volunteer Coordination

export const VOLUNTEER_CATEGORIES = [
  "transport",
  "catering",
  "scoring",
  "setup",
  "first_aid",
  "general",
] as const;
export type VolunteerCategory = (typeof VOLUNTEER_CATEGORIES)[number];

export const EVENT_TASK_STATUSES = ["open", "cancelled"] as const;
export type EventTaskStatus = (typeof EVENT_TASK_STATUSES)[number];

export const ASSIGNMENT_STATUSES = [
  "pending",    // parent claimed; awaiting organiser ack
  "accepted",   // organiser confirmed
  "completed",  // organiser marked done post-event
  "no_show",    // organiser marked no-show post-event
  "cancelled",  // parent unclaimed OR organiser cancelled OR task deleted
] as const;
export type AssignmentStatus = (typeof ASSIGNMENT_STATUSES)[number];

// Free-text-ish codes captured on EventTaskAssignment.cancellation_reason.
// Preserve the source of the cancellation so organisers can tell
// last-minute drop-offs from cancelled-whole-task events.
export const CANCELLATION_REASONS = [
  "parent_unclaimed",
  "organiser_cancelled",
  "task_deleted",
] as const;
export type CancellationReason = (typeof CANCELLATION_REASONS)[number];

export interface EventTaskAssignmentPublic {
  id: string;
  task_id: string;
  user_id: string;
  user_display_name: string;
  status: AssignmentStatus;
  user_notes: string | null;
  organiser_notes: string | null;
  cancellation_reason: CancellationReason | null;
  status_updated_at: string;
  created_at: string;
}

export interface EventTaskPublic {
  id: string;
  event_id: string;
  title: string;
  description: string | null;
  category: VolunteerCategory;
  needed_count: number;
  // Computed: counts only pending + accepted (open) assignments.
  filled_count: number;
  starts_at_local: string | null;
  ends_at_local: string | null;
  contact_user_id: string | null;
  contact_display_name: string | null;
  status: EventTaskStatus;
  // The viewer's own assignment (if any) -- inlined for convenience so the
  // UI can render claim/unclaim without a separate fetch.
  my_assignment: EventTaskAssignmentPublic | null;
  // Populated only on the organiser-side event-detail view.
  assignments?: EventTaskAssignmentPublic[];
  created_at: string;
  updated_at: string;
}

export interface EventTaskListResponse {
  tasks: EventTaskPublic[];
}

export interface EventTaskResponse {
  task: EventTaskPublic;
}

export interface VolunteerOfferPublic {
  id: string;
  user_id: string;
  user_display_name: string;
  user_email: string | null;
  school_id: string;
  school_name: string;
  category: VolunteerCategory;
  title: string;
  description: string | null;
  active: boolean;
  created_at: string;
  updated_at: string;
}

export interface VolunteerOfferListResponse {
  offers: VolunteerOfferPublic[];
}

export interface VolunteerOfferResponse {
  offer: VolunteerOfferPublic;
}

// Filter shape for the organiser-side directory.
export interface VolunteerOfferFilters {
  category?: VolunteerCategory;
  search?: string; // matches title + description
}
